import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { ConfirmationDialog } from '../../../ui'

import { ModalContext } from '../../../ui/modal/contexts'

export const useGuildDialogs = () => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useContext(ModalContext)

  const warnGuildEnterpriseDeletion = (callback) => {
    open({
      Component: ConfirmationDialog,
      data: {
        title: formatMessage({ id: 'pages.guilds.guilds.warning.delete.title' }),
        text: formatMessage({ id: 'pages.guilds.guilds.warning.delete.text' }),
        yesText: formatMessage({ id: 'pages.guilds.guilds.warning.delete.yes' }),
        noText: formatMessage({ id: 'pages.guilds.guilds.warning.delete.no' }),
        yesAction: callback,
      },
      type: 'centered',
    })
  }

  return {
    warnGuildEnterpriseDeletion,
  }
}
